import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const duplicateForm = async (id: number) => {
	const url = `/observations/admin/forms/${id}/duplicate/`;

	const response = await cmsClient.post<{ id: number }>(url, id);
	return response.data;
};

const useDuplicateForm = () => {
	const queryClient = useQueryClient();

	const navigate = useNavigate();
	const onMutate = () => {
		toast.info(
			<CustomToast type="Info" message="Duplicating Form Please Wait..." />
		);
	};

	const onSuccess = ({ id }: { id: number }) => {
		toast.success(<CustomToast type="Success" message="Form is Duplicated" />);

		queryClient.invalidateQueries(["observation-categories"]);

		navigate(`/observations/forms/${id}/questions`);
	};

	const onError = () => {
		toast.error(
			<CustomToast
				type="Error"
				message="There is an error duplicating a form"
			/>,
			{
				autoClose: false
			}
		);
	};

	const mutation = useMutation(duplicateForm, { onMutate, onSuccess, onError });

	return mutation;
};

export default useDuplicateForm;
